var map = {
	"./todomath_main_feature_mode_cn.png": "zh2/",
	"./todomath_main_feature_mode_ja.png": "81D8",
	"./todomath_main_feature_mode_ko.png": "vuga"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "CqWN";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home ^\.\/todomath_main_feature_mode_.*\.png$
// module id = CqWN
// module chunks = 18